import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import Destinations from './components/Destinations';
import FeaturedPackage from './components/FeaturedPackage';
import WhyUkiyo from './components/WhyUkiyo';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import OurStory from './components/OurStory';
import './App.css';

const HomePage = () => (
  <>
    <Helmet>
      <title>Curated International Holidays | Ukiyo Tours</title>
      <meta name="description" content="Experience thoughtfully designed and curated international holidays to Maldives, India, Southeast Asia & Europe with Ukiyo Tours." />
      <meta property="og:title" content="Curated International Holidays | Ukiyo Tours" />
      <meta property="og:description" content="Experience thoughtfully designed and curated international holidays to Maldives, India, Southeast Asia & Europe with Ukiyo Tours." />
      <meta property="og:url" content="https://www.ukiyotours.in/" />
      <meta property="og:type" content="website" />
    </Helmet>
    <Hero />
    <TrustStrip />
    <Destinations />
    <FeaturedPackage />
    <WhyUkiyo />
    <HowItWorks />
    <Testimonials />
    <FinalCTA />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/our-story" element={<OurStory />} />
          </Routes>
          <Footer />
          <FloatingWhatsApp />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
